<div
  class="menu"
  *puLet="{
    role: permissions.role(),
    breakpoints: breakpoints$ | async,
  } as data">
  @if (data.breakpoints.isTablet) {
    <h3 class="pp-gray pp-medium-12">{{ 'menu.title' | translate }}</h3>
  }

  @if (
    !data.breakpoints.isTablet && permissions.role() !== roleEnum.SuperAdmin
  ) {
    <pp-team-selector />
  }

  <pp-nav (click)="navItemClicked.emit($event)" />

  @if (data.role !== roleEnum.SuperAdmin) {
    <pp-rate-conditions class="rate" [role]="data.role" />
  }
</div>
